<template>
  <div class="personage">
    <div class="personageBack"></div>
    <div class="personageTop">
      <div
        v-for="(item, index) in personageList"
        :key="index"
        class="personageCard"
      >
        <div class="personageCardText">
          <div class="personageCardTitle">{{ item.title }}</div>
          <div class="personageCardDesc">{{ item.desc }}</div>
        </div>
        <img :src="item.url" alt="" />
      </div>
    </div>
    <div class="personageTwin m10">
      <div v-for="(item, index) in plusList" :key="index" class="every">
        <img :src="item.url" alt="" />
        <div class="tilte">{{ item.tilte }}</div>
        <div class="texts">{{ item.text }}</div>
      </div>
    </div>
    <div class="businessFlow">
      <h2>业务流程</h2>
      <p>通过平台一站式完成任务派发、费用结算支付、开票和完税</p>
      <img src="@/assets/Slice28.png" alt="" class="businessFlowImage" />
    </div>
    <div class="personageTwin">
      <div v-for="(item, index) in plusList1" :key="index" class="every">
        <img :src="item.url" alt="" />
        <div class="tilte">{{ item.tilte }}</div>
        <div class="texts">{{ item.text }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      personageList: [
        {
          title: "更多工作机会",
          desc: "平台提供多种类型的工作机会，包括兼职、临时工、远程工作、项目制工作等。",
          url: require("@/assets/personage-solution-card-01.png"),
        },
        {
          title: "灵活的工作时间",
          desc: "个人可以根据自己的时间安排选择工作，平衡工作与生活。",
          url: require("@/assets/personage-solution-card-02.png"),
        },
        {
          title: "增加收入来源",
          desc: "通过兼职或临时工作，个人可以增加收入来源，按小时、任务或项目计酬，多劳多得。",
          url: require("@/assets/personage-solution-card-03.png"),
        },
        {
          title: "技能提升与职业发展",
          desc: "通过参与不同类型的工作，个人可以积累丰富的经验，提供技能培训课程，帮助个人提升专业能力。",
          url: require("@/assets/personage-solution-card-04.png"),
        },
        {
          title: "低门槛就业",
          desc: "平台通常提供简化的注册和申请流程，降低求职门槛，不需要长期合同，个人可以自由选择工作机会。",
          url: require("@/assets/personage-solution-card-05.png"),
        },
        {
          title: "平台保障与支持",
          desc: "平台通常提供合规的合同和协议，保障个人的合法权益。",
          url: require("@/assets/personage-solution-card-06.png"),
        },
        {
          title: "快速获得报酬",
          desc: "通常提供透明的薪酬计算方式、通常提供透明的薪酬计算方式，个人可以清楚了解自己的收入。",
          url: require("@/assets/personage-solution-card-07.png"),
        },
        {
          title: "低风险尝试",
          desc: "个人可以通过灵活用工尝试不同的工作和行业，找到最适合自己的方向。",
          url: require("@/assets/personage-solution-card-08.png"),
        },
        {
          title: "数据积累与信用建立",
          desc: "平台记录个人的工作历史和表现，帮助建立职业信用，提升职业声誉。",
          url: require("@/assets/personage-solution-card-09.png"),
        },
      ],
      plusList: [
        {
          url: require("@/assets/Mask_group.png"),
          tilte: "职业发展通道狭窄 技能提升困难",
          text: "从业者长期从事单一工种，缺乏跨领域技能培训机会，难以适应行业技术升级（如自动化焊接设备）。高级技能认证（如高级电工证）需投入更多时间与经济成本，部分人员因资源不足放弃晋升。",
        },
        {
          url: require("@/assets/Mask_group(1).png"),
          tilte: "就业机会分散 供需匹配效率低",
          text: "传统招聘渠道（如中介、熟人介绍）效率低下，缺乏统一的信息平台，导致岗位需求与技能人才匹配困难。",
        },
        {
          url: require("@/assets/Mask_group(3).png"),
          tilte: "‌行业监管缺位 纠纷解决困难",
          text: "黑中介泛滥：部分非法中介以“高薪”为诱饵收取押金，最终未兑现承诺，从业者维权成本高。劳动纠纷处理难：临时工与企业间多为口头协议，缺乏书面合同，发生纠纷时难以举证。政府监管覆盖不足：偏远地区或小型工地监管薄弱，无证上岗、违规操作现象屡禁不止。",
        },
        {
          url: require("@/assets/Mask_group(2).png"),
          tilte: "安全风险高 职业健康隐患大",
          text: "安全培训不足：部分企业为降低成本，简化安全培训流程，导致作业人员操作不规范。防护设备缺失：高空作业、电焊等场景中，企业未提供合格防护装备（如安全带、防火服），增加事故风险。职业病威胁：长期接触有害环境（如粉尘、高温、噪音），易引发职业病，但健康检查与赔偿机制不完善",
        },
      ],

      plusList1: [
        {
          url: require("@/assets/Mask_group(4).png"),
          tilte: "稳定就业",
          text: "渴望获得稳定的工作机会，减少失业风险，保障生活稳定。",
        },
        {
          url: require("@/assets/Mask_group(5).png"),
          tilte: "技能提升",
          text: "希望有更多的培训和学习机会，提升自身技能水平，增强就业竞争力。",
        },
        {
          url: require("@/assets/Mask_group(7).png"),
          tilte: "收入增长",
          text: "通过提升技能和获得更多工作机会，实现薪资水平的提高。",
        },
        {
          url: require("@/assets/Mask_group(6).png"),
          tilte: "权益保障",
          text: "确保自身在工作中的合法权益得到保障。",
        },
      ],
    };
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.personage {
  position: relative;
  .personageBack {
    width: 100%;
    height: 1165px;
    border-radius: 0px 0px 0px 0px;
    background: url("@/assets/personage-solution-banner.png") center top /
      1920px 1165px no-repeat;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
  }
}
.personageTop {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: repeat(3, 440px);
  justify-content: center;
  gap: 80px 64px;
  box-sizing: border-box;
  min-height: 1060px;
  padding: 120px 0 96px;
}
.personageCard {
  width: 440px;
  height: 250px;
  position: relative;
  box-sizing: border-box;
  padding: 56px 44px;
  overflow: hidden;
  text-align: left;
  background: #f5f7fb;
  border-radius: 16px;
}
.personageCardText {
  position: relative;
  z-index: 2;
  width: 258px;
}
.personageCardTitle {
  font-weight: 600;
  font-size: 24px;
  color: #141414;
  line-height: 32px;
  margin-bottom: 28px;
}
.personageCardDesc {
  font-weight: 400;
  font-size: 16px;
  color: #141414;
  line-height: 28px;
}
.personageCard img {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 140px;
  height: 140px;
  object-fit: contain;
  user-select: none;
}
.m10 {
  margin-top: 10px;
}
.personageTwin {
  background: #f4f7fc;
  padding: 104px 360px 68px 360px;
  display: flex;
  .every {
    width: 280px;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(140, 140, 140, 0.25);
    border-radius: 24px 24px 24px 24px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #141414;
    line-height: 32px;
    padding: 88px 40px 42px 40px;
    text-align: left;
    position: relative;
    margin-right: 22px;
    .tilte {
      font-weight: 500;
      font-size: 20px;
      color: #141414;
      padding-bottom: 56px;
      border-bottom: 1px solid #e4e7ed;
      text-align: center;
    }
    .texts {
      margin-top: 30px;
    }
    img {
      width: 136px;
      height: 136px;
      position: absolute;
      top: -78px;
      left: 72px;
    }
  }
}

.businessFlow {
  box-sizing: border-box;
  padding: 92px 0 110px;
  background: #ffffff;
  text-align: center;
  h2 {
    margin: 0 0 18px;
    font-weight: 600;
    font-size: 28px;
    color: #141414;
    line-height: 40px;
  }
  p {
    margin: 0 0 82px;
    font-weight: 400;
    font-size: 14px;
    color: #141414;
    line-height: 22px;
  }
}
.businessFlowImage {
  width: 1400px;
  height: 440px;
  display: block;
  margin: 0 auto;
  object-fit: contain;
}

@media (max-width: 750px) {
  .personageTop {
    grid-template-columns: 1fr;
    gap: 32px;
    padding: 52px 32px;
  }
  .personageCard {
    width: 100%;
    height: 268px;
    padding: 42px 36px;
  }
  .personageCardText {
    width: 360px;
  }
  .personageCardTitle {
    font-size: 28px;
    line-height: 36px;
    margin-bottom: 24px;
  }
  .personageCardDesc {
    font-size: 22px;
    line-height: 34px;
  }
  .personageCard img {
    width: 168px;
    height: 168px;
  }
  .personageTwin {
    padding: 104px 160px 68px 160px;
  }
  .businessFlowImage {
    width: 1400px;
    height: 440px;
  }
}
</style>
